import http from '~/common/http'
export default {
    // 销售提成业绩
    getList(params, action) {
        return http.get('/api/performance-calc/' + action, {
            params: params
        });
    },

    getCollectDetail(params) {
        return http.get('/api/performance-calc/collect-detail', {
            params: params
        });
    },

    getConfirmDetail(params) {
        return http.get('/api/performance-calc/confirm-detail', {
            params: params
        });
    },
}


// WEBPACK FOOTER //
// ./src/services/PerformanceCalcCount.js